<template>
  <div class="comp-job fit-height">
    <div v-if="JOB">
      <div class="job-head details-head">
        <ul class="meta">
          <li>{{ (JOB.client.code?JOB.client.code:'') + jobId }}</li>
          <li>{{ JOB.client.name }}</li>
          <li v-if="IS_CLIENT"> {{ status | statusToUCWords }}</li>
          <li v-else>
            <div class="dropdown">
              <a href="javascript:;" class="status dropdown-toggle" :class="status" data-toggle="dropdown" @click="showStatusDropdown = !showStatusDropdown">{{ status | statusToUCWords}}</a>
              <div class="dropdown-menu" :class="{show: showStatusDropdown == true}">
                <a class="dropdown-item" href="javascript:;" @click="updateStatus(jstatus)" v-for="jstatus in jobStatuses" :key="jstatus" :value="jstatus">
                  {{ jstatus | statusToUCWords }}
                </a>
              </div>
            </div>
          </li>
        </ul>
        <div class="inn">
          <div class="job-info">
            <div class="title">
              <template v-if="editJobName">
                <form method="post" action="" @submit.prevent="updateName">
                  <input type="text" class="form-control" v-model="newJobName" ref="inputTitle" @blur="updateName">
                </form>
              </template>
              <template v-else>
                <span>{{ JOB.name }}</span>
                <a href="javascript:;" class="edit icon-pencil"
                  @click="editJobName = true"></a>
              </template>
            </div>
            <div class="form-row">
              <label style="color: #000;" class="lb">DUE DATE</label>
              <div class="inputs">
                <date-picker format="DD-MM-YYYY" value-type="YYYY-MM-DD" v-model="JOB.due_date" @change="updateDueDate" :editable="false" input-class="form-control" style="display: inline-block;"></date-picker>
              </div>
            </div>
            <!--
            <template v-if="editDescription">
              <form method="post" @submit.prevent="updateDescription">
                <div class="form-group">
                  <editor :api-key="tinyApiKey" :init="tinyOpts" v-model="newDescription"></editor>
                </div>
                <button type="submit" class="btn btn-outline-black">Submit</button>&nbsp;
                <button type="button" class="btn btn-outline-gray" @click="editDescription = false">Cancel</button>
              </form>
            </template>
            <template v-else>
              <div class="desc">
                <div v-if="JOB.description" v-html="JOB.description"></div>
                <div v-else><em>No description...</em></div>
              </div>
              <button type="button" class="btn btn-outline-black w180 mt-4" @click="editDescription = true">Edit</button>
            </template>
            -->
          </div>
          <div v-if="!IS_CLIENT">
            <job-finance></job-finance>
            <job-resources></job-resources>
          </div>
        </div>
      </div>

      <job-tasks></job-tasks>

      <div class="with-sidebar">
        <div class="body">
          <ul class="comment-tabs">
            <li v-if="!IS_CLIENT"><a href="javascript:;" :class="{active: commentTab == 'team'}"
              @click="commentTab = 'team'">TEAM DISCUSSION</a></li>
            <li><a href="javascript:;" :class="{active: commentTab == 'client'}"
              @click="commentTab = 'client'">CLIENT DISCUSSION</a></li>
          </ul>

          <board-comments v-if="commentTab == 'team' && !IS_CLIENT" key="team-comments"
                          :taggable-items="taggableItemsTeam"
                          object-type="job" :object-id="JOB.id" board="team"></board-comments>

          <board-comments v-else-if="commentTab == 'client'" key="client-comments"
                          :taggable-items="taggableItemsClient"
                          object-type="job" :object-id="JOB.id" board="client"></board-comments>
        </div>

        <aside class="sidebar">
          <attachments></attachments>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import { forEach } from 'lodash'
import { mapGetters, mapState } from 'vuex'
import ServiceJob from '@/services/job'
import BoardComments from '../global/BoardComments'
import Attachments from './Attachments.vue'
import JobTasks from './JobTasks.vue'
import JobFinance from './JobFinance.vue'
import JobResources from './JobResources.vue'
//import Editor from '@tinymce/tinymce-vue'
import DatePicker from 'vue2-datepicker'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  components: {
    Attachments,
    BoardComments,
    JobTasks,
    JobFinance,
    JobResources,
    //Editor,
    DatePicker
  },
  data () {
    return {
      state: '',
      status: 'pending',
      project_id: '',
      allClientProjects: [],
      updated_dtm: 0,
      editDescription: false,
      newDescription: '',
      editJobName: false,
      newJobName: '',
      commentTab: 'team',
      showStatusDropdown: false
    }
  },
  props: ['jobId'],
  watch: {
    editJobName (newVal) {
      let self = this;
      if ( newVal ) {
        self.newJobName = self.JOB.name;
        setTimeout(() => {
          self.$refs.inputTitle.focus();
        }, 200);
      }
    },
    editDescription (newVal) {
      let self = this;
      if ( newVal ) {
        self.newDescription = self.JOB.description;
      }
    },
  },
  computed: {
    ...mapGetters(['JOB', 'OPTIONS', 'IS_CLIENT', 'CURRENT_USER']),
    ...mapState({
      tinyApiKey: state => state.option.tinyApiKey,
      tinyOpts: state => state.option.tinyOpts,
      allProjects: state => state.option.projects,
      jobStatuses: state => state.option.jobStatuses
    }),
    canManageJob () {
      return this.OPTIONS.logged_as != 'client';
    },
    taggableItemsTeam () {
      let self = this, items = [];
      forEach(self.JOB.client.company.users, o => {
        items.push({
          value: o.full_name,
          id: o.username
        })
      });
      return items;
    },
    taggableItemsClient () {
      let self = this, items = [];
      forEach(self.JOB.client.members, o => {
        items.push({
          value: o.full_name,
          id: o.username
        })
      });
      return items;
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.$store.dispatch('GET_JOB', self.jobId)
        .then(() => {
          if (self.IS_CLIENT && self.JOB.client_id != self.CURRENT_USER.client_id){
            /* Try to access other jobs via url */
            self.$notify({
              type: 'error',
              title: 'Invalid Request',
              text: 'You are not allowed to view this job.',
            });
            self.$router.push({name: 'jobs'});
          }
          self.status = self.JOB.status;
          //self.project_id = self.JOB.project_id?self.JOB.project_id:'';
          if ( self.canManageJob ) {
            self.commentTab = 'team';
          }
          else {
            self.commentTab = 'client';
          }
          /*
          self.allClientProjects = [];
          for(let i in self.allProjects){
            if(self.allProjects[i].client_id == self.JOB.client_id)
              self.allClientProjects.push(self.allProjects[i]);
          }
          */
        });
    },
    updateName () {
      let self = this;
      // save to DB
      setTimeout(() => {
        if(self.newJobName != self.JOB.name){
          self.JOB.name = self.newJobName;
          self.saveJob({name: self.newJobName});
        }
        self.editJobName = false;
      }, 1000);
    },
    updateDescription () {
      let self = this;
      // save to DB
      setTimeout(() => {
        if(self.newDescription != self.JOB.description){
          self.JOB.description = self.newDescription;
          self.saveJob({description: self.newDescription});
        }
        self.editDescription = false;
      }, 1000);
    },
    updateStatus (newStatus) {
      let self = this;
      if(newStatus != self.status){
        self.status = newStatus;
        self.saveJob({status: newStatus});
      }
      self.showStatusDropdown = false;
    },
    updateDueDate () {
      this.saveJob({due_date: this.JOB.due_date});
    },
    saveJob (updateData) {
      let self = this;
      if (self.state == 'saving') {
        return;
      }
      self.state = 'saving';
      ServiceJob.save(self.JOB.id, updateData, job => {
        let now = new Date().getTime();
        if(now - self.updated_dtm > 5*1000){
          self.$notify({
            type: 'success',
            text: 'Job updated'
          });
          self.updated_dtm = now;
        }
        self.state = '';
        self.status = job.status;
        self.$store.dispatch('UPDATE_JOB', job)
      }, () => {
        self.state = '';
      });
    }
  }
}
</script>
